module.exports = __webpack_public_path__ + "static/media/Emergency Document delivery.d4e3d7b5.png";